<template>
	<SwiperSlide>
		<img
			:src="src"
			:srcset="srcset"
			:class="{
				loaded,
			}"
			@load="load"
		/>
		<Spinner stroke="#fff" v-if="!loaded" />
		<div class="text" aria-hidden="true">
			<h2 v-if="headline" v-html="headline" class="headline"></h2>
			<div v-if="description" v-html="description" class="description"></div>
			<div v-if="attribution" v-html="attribution" class="attribution"></div>
		</div>
	</SwiperSlide>
</template>
<script>
import { SwiperSlide } from 'vue-awesome-swiper';
import Spinner from '@/components/elementSub/spinner.vue';

export default {
	name: 'GallerySlide',
	props: {
		mediaObject: { type: Object, required: true },
	},
	data() {
		return {
			loaded: false,
		};
	},
	components: {
		SwiperSlide,
		Spinner,
	},
	computed: {
		language() {
			return this.$store.state.persistent.language;
		},
		isSyncerApp() {
			return this.$store.state.packageSyncer.isSyncerApp;
		},
		source() {
			if (!this.mediaObject) return;
			const source = this.mediaObject.Sources[this.language];
			if (!source) return null;
			return source.endsWith('/1024') ? source.replace('/1024', '') : source;
		},
		src() {
			if (this.isSyncerApp) return `${this.source}/2048`;
			return `${this.source}/512`;
		},
		srcset() {
			return !this.isSyncerApp
				? [512, 1024, 2048]
						.sort((a, b) => a - b)
						.map((size) => `${this.source}/${size} ${size}w`)
						.join(', ')
				: '';
		},
		alt() {
			return this.mediaObject.Alt[this.language];
		},
		headline() {
			return this.mediaObject.Title[this.language];
		},
		description() {
			return this.mediaObject.Desc[this.language];
		},
		attribution() {
			return this.mediaObject.Attribution[this.language];
		},
	},
	methods: {
		load() {
			this.loaded = true;
		},
	},
};
</script>
<style scoped>
img {
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	width: 100vw;
	height: 100vh;
	display: block;
	object-fit: contain;
	object-position: center;
	opacity: 0;
	transition: 0.5s opacity;
}
img.loaded {
	opacity: 1;
}
</style>
